import styled from '@emotion/styled';
import { Z_ERROR_CONTENT_WRAPPER } from '@embed/components/VideoPlayer/Player3/constants/zIndexes';
export const ErrorContentWrapper = styled.div `
  background: var(--gray3);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 15px;
  width: 100%;
  position: relative;
  z-index: ${Z_ERROR_CONTENT_WRAPPER};
`;
export const Title = styled.div `
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  text-align: center;
  color: #fff;
  margin-bottom: 25px;
`;
export const Description = styled.div `
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: #fff;
  margin-bottom: 25px;
`;
